import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
import { getKunjunganAllMarketing } from "stores";
import ReactPaginate from "react-paginate";
import ListKunjunganMarketing from "./ListKunjunganMarketing";

const KunjunganMarketing = () => {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0,
    ),
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [idCabang, setIdCabang] = React.useState("");
  const [idMarketing, setIdMarketing] = React.useState("");
  const [listDataMarketing, setListDataMarketing] = React.useState([]);
  const [sendDataKunjungan, setSendDataKunjungan] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    setPage(0);
    getKunjunganAllMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      cari: searchText,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleDetailsClick = (val) => {
    dispatch({ type: "SET_DETAIL_KUNJUNGAN", data: false });
    setSendDataKunjungan(val.kunjungan);
  };

  React.useEffect(() => {
    if (kunjungan.getKunjunganAllMarketing.docs) {
      let tmp = kunjungan.getKunjunganAllMarketing.docs.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`t-detail-${val._id}`}>
                    Lihat Detail Performa
                  </Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "10px",
                    backgroundColor: "#E0F2FE", // Soft Blue
                    border: "1px solid #BAE6FD",
                    color: "#0369A1",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#0369A1";
                    e.currentTarget.style.color = "#ffffff";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#E0F2FE";
                    e.currentTarget.style.color = "#0369A1";
                  }}
                  onClick={() => handleDetailsClick(val)}
                >
                  <i className="fas fa-eye" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
      setListDataMarketing(tmp);
    }
  }, [kunjungan.getKunjunganAllMarketing]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F1F5F9",
        minHeight: "50px",
        borderTop: "1px solid #E2E8F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "11px",
        color: "#475569",
        textTransform: "uppercase",
        justifyContent: "center",
      },
    },
    rows: {
      style: {
        minHeight: "70px",
        "&:hover": {
          backgroundColor: "#F8FAFC",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        color: "#1E293B",
        justifyContent: "center",
      },
    },
  };

  const colKunjungan = [
    {
      name: "NO",
      width: "70px",
      center: true,
      selector: (row, index) =>
        index + kunjungan.getKunjunganAllMarketing.pagingCounter,
      style: { fontWeight: "bold", color: "#94A3B8" },
    },
    {
      name: "PROFIL MARKETING",
      minWidth: "280px",
      cell: (row) => (
        <div className="py-2 w-100">
          <div className="fw-800 text-dark" style={{ fontSize: "14px" }}>
            {row.nama}
          </div>
          <div className="d-flex mt-1" style={{ gap: "6px" }}>
            <span
              className="badge bg-light text-muted border fw-600"
              style={{ fontSize: "13px" }}
            >
              ID: {row.nopeg}
            </span>
            <span
              className="badge bg-light text-muted border fw-600"
              style={{ fontSize: "13px" }}
            >
              NIK: {row.nik}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "UNIT / CABANG",
      minWidth: "270px",
      center: true,
      cell: (row) => (
        <div
          className="rounded bg-white border shadow-xs d-flex align-items-center justify-content-start px-3 py-2 w-100"
          style={{
            minHeight: "45px",
            borderLeft: "4px solid #F75D59",
          }}
        >
          <div
            className="mr-2 d-flex align-items-center justify-content-center"
            style={{ width: "20px", flexShrink: 0 }}
          >
            <i
              className="fas fa-map-marker-alt text-danger"
              style={{ fontSize: "14px" }}
            ></i>
          </div>

          <div
            className="text-dark fw-700 text-left text-truncate"
            style={{
              fontSize: "12px",
              fontWeight: "700",
              lineHeight: "1.2",
              flex: 1,
            }}
          >
            {row.cabang?.namaCabang || "-"}
          </div>
        </div>
      ),
    },
    {
      name: "JABATAN",
      minWidth: "180px",
      cell: (row) => (
        <div
          className="text-center py-1 px-2 rounded-pill bg-light text-muted border"
          style={{ fontSize: "10px", fontWeight: "800" }}
        >
          {row.role === "marketing" ? "SALES MARKETING" : "DIRECT MARKETING"}
        </div>
      ),
    },
    {
      name: "TOTAL KUNJUNGAN",
      minWidth: "180px",
      center: true,
      cell: (row) => (
        <div className="text-center">
          <div className="fw-800 text-primary" style={{ fontSize: "16px" }}>
            {row.totalKunjungan}
          </div>
          <div className="text-muted small fw-bold" style={{ fontSize: "9px" }}>
            KUNJUNGAN
          </div>
        </div>
      ),
    },
    {
      name: "STATUS",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isAktif = row.status === "aktif";
        return (
          <span
            style={{
              fontSize: "11px",
              fontWeight: "800",
              padding: "6px 12px",
              borderRadius: "20px",
              backgroundColor: isAktif ? "#DCFCE7" : "#F1F5F9",
              color: isAktif ? "#15803D" : "#64748B",
              border: isAktif ? "1px solid #BBF7D0" : "1px solid #E2E8F0",
            }}
          >
            {isAktif ? "AKTIF" : "NON-AKTIF"}
          </span>
        );
      },
    },
    {
      name: "AKSI",
      width: "100px",
      center: true,
      cell: (row) => (
        <div className="d-flex justify-content-center">{row.action}</div>
      ),
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getKunjunganAllMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      cari: "",
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir, page, totalPerHalaman]);
  return (
    <>
      {kunjungan.detailGetKunjunganAllMarketing ? (
        <Container fluid className="py-4">
          <Row>
            <Col md="12">
              <Card className="border-0 shadow-sm rounded-xl">
                {/* HEADER AREA */}
                <Card.Header className="bg-white border-0 pt-4 px-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h3
                        className="fw-800 text-dark m-0"
                        style={{ letterSpacing: "1px" }}
                      >
                        LIST KUNJUNGAN MARKETING
                      </h3>
                      <p className="text-muted small mb-0">
                        Monitor rekapitulasi kunjungan tim marketing secara
                        mendalam.
                      </p>
                    </div>
                    <div className="bg-light-blue px-3 py-2 rounded-pill border border-info-subtle d-none d-md-block">
                      <span className="text-primary fw-bold small">
                        <i className="fas fa-chart-line mr-2"></i> Performance
                        Tracker
                      </span>
                    </div>
                  </div>
                  <hr className="mb-4" />

                  {/* SMART TOOLBAR: Unified Filters & Search */}
                  <div className="bg-light p-3 rounded-xl border-0 shadow-inner">
                    <Row className="align-items-end g-3">
                      {/* Filter Tanggal Awal */}
                      <Col lg={2} md={3} sm={6}>
                        <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                          Mulai
                        </label>
                        <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                          <ReactDatetime
                            inputProps={{
                              className: "form-control border-0 bg-transparent",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                fontWeight: "600",
                                color: "#334155",
                                fontSize: "13px",
                              },
                            }}
                            onChange={(e) => {
                              const date = e.toDate
                                ? e.toDate().setHours(0, 0, 0, 0)
                                : e;
                              setTglAwal(date);
                            }}
                            value={tglAwal}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </Col>

                      {/* Filter Tanggal Akhir */}
                      <Col lg={2} md={3} sm={6}>
                        <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                          Sampai
                        </label>
                        <div className="date-picker-wrapper shadow-sm rounded-lg bg-white p-1">
                          <ReactDatetime
                            inputProps={{
                              className: "form-control border-0 bg-transparent",
                              readOnly: true,
                              style: {
                                cursor: "pointer",
                                fontWeight: "600",
                                color: "#334155",
                                fontSize: "13px",
                              },
                            }}
                            onChange={(e) => {
                              const date = e.toDate
                                ? e.toDate().setHours(0, 0, 0, 0)
                                : e;
                              setTglAkhir(date);
                            }}
                            value={tglAkhir}
                            timeFormat={false}
                            closeOnSelect={true}
                          />
                        </div>
                      </Col>

                      {/* Search Bar */}
                      <Col
                        lg={4}
                        md={4}
                        sm={12}
                        className="ml-auto mt-3 mt-md-0"
                      >
                        <label className="text-muted small fw-bold uppercase mb-2 d-block ml-1">
                          Cari Marketing
                        </label>
                        <InputGroup className="bg-white rounded-lg border shadow-sm">
                          <InputGroup.Prepend>
                            <InputGroup.Text className="bg-transparent border-0 text-muted">
                              <i className="fas fa-search"></i>
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control
                            className="border-0 bg-transparent"
                            style={{
                              height: "42px",
                              boxShadow: "none",
                              fontSize: "14px",
                            }}
                            type="text"
                            value={searchText}
                            onChange={handleSearch}
                            placeholder="Ketik nama marketing..."
                            onKeyDown={handleKeyDown}
                          />
                          {searchText && (
                            <InputGroup.Append>
                              <InputGroup.Text
                                className="bg-transparent border-0 text-muted cursor-pointer"
                                onClick={handleClearSearch}
                              >
                                <i className="fas fa-times"></i>
                              </InputGroup.Text>
                            </InputGroup.Append>
                          )}
                        </InputGroup>
                      </Col>
                    </Row>
                  </div>
                </Card.Header>

                {/* BODY AREA */}
                <Card.Body className="px-4 pb-4">
                  {isLoading ? (
                    <div className="py-5 text-center d-flex flex-column align-items-center">
                      <Watch height="70" width="70" color="#577d86" />
                      <h5 className="mt-4 fw-600 text-muted animate-pulse">
                        Menghitung Data Kunjungan...
                      </h5>
                    </div>
                  ) : (
                    <div className="table-responsive-custom mt-3">
                      <DataTable
                        columns={colKunjungan}
                        data={listDataMarketing}
                        customStyles={customStyles}
                        pagination={false}
                        highlightOnHover
                        pointerOnHover
                      />

                      {/* PAGINATION FOOTER */}
                      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pt-4 border-top">
                        <div className="d-flex align-items-center mb-3 mb-md-0">
                          <span className="text-muted small fw-bold mr-3">
                            Show
                          </span>
                          <div style={{ width: "90px" }}>
                            <Select
                              classNamePrefix="react-select"
                              value={options.find(
                                (opt) => opt.value === totalPerHalaman,
                              )}
                              onChange={handlePageSizeChange}
                              options={options}
                              menuPlacement="top"
                            />
                          </div>
                          <span className="text-muted small ml-2">entries</span>
                        </div>

                        <ReactPaginate
                          forcePage={page}
                          containerClassName="pagination mb-0"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          activeClassName="active"
                          pageCount={
                            kunjungan.getKunjunganAllMarketing.totalPages || 1
                          }
                          onPageChange={(val) => setPage(val.selected)}
                          nextLabel=">"
                          previousLabel="<"
                        />
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <style>{`
    .fw-800 { font-weight: 800; }
    .rounded-xl { border-radius: 20px !important; }
    .rounded-lg { border-radius: 12px !important; }
    .shadow-inner { box-shadow: inset 0 2px 5px 0 rgba(0,0,0,0.05); }
    .bg-light-blue { background-color: #f0f9ff; }
    
    .pagination .page-link {
        border-radius: 8px !important;
        margin: 0 3px;
        color: #577d86;
        border: 1px solid #e2e8f0;
    }
    .pagination .active .page-link {
        background-color: #577d86 !important;
        border-color: #577d86 !important;
        color: white;
    }

    @keyframes pulse {
      0% { opacity: 1; }
      50% { opacity: 0.5; }
      100% { opacity: 1; }
    }
    .animate-pulse { animation: pulse 2s infinite; }
  `}</style>
        </Container>
      ) : (
        <>
          <ListKunjunganMarketing data={sendDataKunjungan} />
        </>
      )}
    </>
  );
};

export default KunjunganMarketing;
